import { PropTypes } from "prop-types";
import { useMemo } from "react";
import { connectSearchBox } from "react-instantsearch-dom";

import { Link } from "@components/al_components/ALLink";
import Categories from "./Categories";
import SearchCards from "./topSearches/SearchCards";
import SearchLinks from "./topSearches/SearchLinks";

const searchMappings = [
  { search: "al luxe", name: "Meet AL Luxe", link: "/welcome-to-ana-luisa-luxe/" },
  { search: "luxe", name: "Meet AL Luxe", link: "/welcome-to-ana-luisa-luxe/" },
  { search: "membership", name: "Meet AL Luxe", link: "/welcome-to-ana-luisa-luxe/" },
  { search: "subscription", name: "Meet AL Luxe", link: "/welcome-to-ana-luisa-luxe/" },
  // {
  //   search: "al luxe",
  //   name: "FAQs",
  //   link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  // },
  // { search: "luxe", name: "FAQs", link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT" },
  // {
  //   search: "membership",
  //   name: "FAQs",
  //   link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  // },
  // {
  //   search: "subscription",
  //   name: "FAQs",
  //   link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  // },
  // {
  //   search: "cancel membership",
  //   name: "FAQs",
  //   link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  // },
  // {
  //   search: "pause membership",
  //   name: "FAQs",
  //   link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  // },
  // {
  //   search: "skip membership",
  //   name: "FAQs",
  //   link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  // },
  { search: "cancel membership", name: "Manage my membership", link: "/ana-luisa-luxe/" },
  { search: "pause membership", name: "Manage my membership", link: "/ana-luisa-luxe/" },
  { search: "skip membership", name: "Manage my membership", link: "/ana-luisa-luxe/" },
  { search: "track", name: "Track my order", link: "/track-my-order/" },
  { search: "track my order", name: "Track my order", link: "/track-my-order/" },
  {
    search: "where is my order",
    name: "Track my order",
    link: "/track-my-order/",
  },
  {
    search: "permanent",
    name: "Permanent Jewelry",
    link: "/permanent-jewelry/",
  },
  {
    search: "return",
    name: "Returns",
    link: "https://help.analuisa.com/en-US/articles/exchanges-and-returns-370783",
  },
  {
    search: "exchange",
    name: "Exchanges",
    link: "https://help.analuisa.com/en-US/articles/exchanges-and-returns-370783",
  },
  {
    search: "shipping",
    name: "Shipping",
    link: "https://help.analuisa.com/en-US/articles/shipping-370766",
  },
  {
    search: "gift card",
    name: "Gift Card",
    link: "https://help.analuisa.com/en-US/articles/payment-and-gift-cards-370782",
  },
  { search: "wismo", name: "Track my order", link: "/track-my-order/" },
  {
    search: "label",
    name: "Returns",
    link: "https://help.analuisa.com/en-US/articles/exchanges-and-returns-370783",
  },
  {
    search: "file a claim",
    name: "Warranty FAQs",
    link: "https://help.analuisa.com/en-US/do-your-products-come-with-a-warranty-4467787",
  },
  {
    search: "claim",
    name: "Warranty FAQs",
    link: "https://help.analuisa.com/en-US/do-your-products-come-with-a-warranty-4467787",
  },
  {
    search: "tarnish",
    name: "Warranty FAQs",
    link: "https://help.analuisa.com/en-US/do-your-products-come-with-a-warranty-4467787",
  },
  {
    search: "broken",
    name: "Warranty FAQs",
    link: "https://help.analuisa.com/en-US/do-your-products-come-with-a-warranty-4467787",
  },
  {
    search: "warranty",
    name: "Warranty FAQs",
    link: "https://help.analuisa.com/en-US/do-your-products-come-with-a-warranty-4467787",
  },
  {
    search: "file a claim",
    name: "Warranty Inquiries",
    link: "/warranty/",
  },
  {
    search: "claim",
    name: "Warranty Inquiries",
    link: "/warranty/",
  },
  {
    search: "warranty",
    name: "Warranty Inquiries",
    link: "/warranty/",
  },
  {
    search: "tarnish",
    name: "Warranty Inquiries",
    link: "/warranty/",
  },
  {
    search: "broken",
    name: "Warranty Inquiries",
    link: "/warranty/",
  },
  {
    search: "last chance",
    name: "Last Chance",
    link: "/collections/last-chance/",
  },
  {
    search: "final sale",
    name: "Last Chance",
    link: "/collections/last-chance/",
  },
  {
    search: "store",
    name: "Store",
    link: "/pages/retail/",
  },
  {
    search: "services",
    name: "Services",
    link: "/permanent-jewelry/",
  },
  {
    search: "custom",
    name: "Custom Jewelry",
    link: "/permanent-jewelry/",
  },
  {
    search: "custom jewelry",
    name: "Custom Jewelry",
    link: "/permanent-jewelry/",
  },
  { search: "customer service", name: "FAQ", link: "https://help.analuisa.com/" },
  { search: "chat", name: "Chat with us", link: "https://help.analuisa.com/" },
  { search: "help", name: "FAQ", link: "https://help.analuisa.com/" },
];

function TopSearches({
  refine,
  searchQuery = null,
  topCategories,
  cards,
  nbHits,
  currentRefinement,
  links,
}) {
  const lookingFor = useMemo(() => {
    if (!searchQuery) return [];
    const seen = new Set();
    return searchMappings
      .filter((item) => {
        const itemSearch = item.search.toLowerCase();
        const query = searchQuery.toLowerCase();
        return itemSearch.includes(query) || query.includes(itemSearch);
      })
      .map((item) => ({ name: item.name, link: item.link }))
      .filter((item) => {
        if (seen.has(item.link)) return false;
        seen.add(item.link);
        return true;
      });
  }, [searchQuery]);

  const lookingForElement = useMemo(
    () =>
      lookingFor &&
      lookingFor.length > 0 && (
        <div
          data-testid="looking-for"
          className="flex flex-col gap-[15px] mobile:gap-[20px] mb-[60px] mobile:mb-[40px]"
        >
          <h3 className="typo-h2 font-bold">Are you looking for:</h3>
          {lookingFor.map((item) => (
            <Link
              key={`looking_for_search_${item.link}`}
              to={item.link}
              className="typo-body underline font-bold"
            >
              {item.name}
            </Link>
          ))}
        </div>
      ),

    [lookingFor]
  );

  if (currentRefinement && nbHits > 0) {
    if (lookingFor && lookingFor.length > 0) {
      return (
        <div
          data-testid="looking-for-grid"
          className="w-full grid [grid-template-columns:50%_50%] mobile:[grid-template-columns:100%] mobile:px-[15px] overflow-hidden mt-[35px]"
        >
          <div className="flex flex-col">{lookingForElement}</div>
        </div>
      );
    }
    return null;
  }

  const showCategories =
    topCategories &&
    topCategories.length > 0 &&
    topCategories.some((cat) => cat.toLowerCase() !== "null");

  return (
    <div className="w-full grid [grid-template-columns:50%_50%] mobile:[grid-template-columns:100%] mobile:px-[15px] overflow-hidden mt-[35px]">
      <div className="flex flex-col">
        {lookingForElement}

        {nbHits === 0 && !links && lookingFor.length === 0 && (
          <div data-testid="no-matches">
            <h3 className="typo-h2 font-bold mb-[20px] mobile:mb-[15px]">No matches found</h3>
            <p className="typo-body mb-[40px]">
              Try another search or maybe we can interest you with these popular search terms:
            </p>
          </div>
        )}

        {showCategories && (
          <Categories
            refine={refine}
            categories={topCategories}
            currentRefinement={currentRefinement}
            nbLinks={links?.length || 0}
          />
        )}
        <SearchLinks links={links} nbHits={nbHits} currentRefinement={currentRefinement} />
      </div>
      {nbHits > 0 && cards && cards.length > 0 && <SearchCards cards={cards} />}
    </div>
  );
}

TopSearches.propTypes = {
  refine: PropTypes.func,
  topCategories: PropTypes.arrayOf(PropTypes.string),
  searchQuery: PropTypes.string,
  cards: PropTypes.arrayOf(PropTypes.shape({})),
  nbHits: PropTypes.number,
  currentRefinement: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({})),
};

export default connectSearchBox(TopSearches);
